import request from '@/API/request';

// 平台登录接口
export function loginPlatform(data) {
  return request({
    url: '/auth/api/oauth/login',
    method: 'post',
    data,
  });
}

// 平台登出接口
export function logoutPlatform() {
  return request({
    url: '/auth/api/oauth/logout',
    method: 'post',
  });
}

// 平台保活接口
export function keepalive() {
  return request({
    url: '/auth/api/oauth/keepalive',
    method: 'post',
    headers:{
      //'Authorization':`Bearer ${localStorage.getItem('ordinaryToken')?localStorage.getItem('ordinaryToken'):localStorage.getItem('supervisionToken')}`
      'Authorization':`Bearer ${localStorage.getItem('ordinaryToken')}`
    }
  });
}
// 获取验证码
export function getVerificationCode(deviceid) {
  return request({
    url: `auth/api/oauth/captcha?deviceId=${deviceid}`,
    method: 'get',
    responseType: 'arraybuffer',
  });
}
// 注册用户信息

export function registerRoles(data) {
  return request({
    url: `auth/api/user/register`,
    method: 'post',
    data
  });
}

// 获取权限目录

export function getRolesMenus() {
  return request({
    url: `auth/api/permission/1002/list`,
    method: 'get',
  });
}

// 注册协会会员信息
export function memberApply(data) {
  return request({
    url: `auth/api/member-apply`,
    method: 'post',
    data
  });
}

// 获取协会会员信息
export function getMemberApply(userId) {
  return request({
    url: `auth/api/member-apply/user/${userId}`,
    method: 'get',
  });
}
